/**
 *
 * @typedef Languages
 * @returns {{
 *  get(): Promise,
 *  save(slug: string, inputs: object): Promise,
 * }}
 */
export const Languages = axios => ({
  /**
   * Save Languages form
   *
   * @param payload: object
   * @param slug: string
   * @returns Promise
   */
  save (slug, payload) {
    return axios.put(`/v1/profiles/${slug}/languages`, payload)
  },
  /**
   * Get languages list
   *
   * @param slug: string
   * @returns Promise
   */
  list (slug) {
    return axios.get(`/v1/profiles/${slug}/languages`)
  }
})
